import React, { Component } from 'react';
import { Grid } from 'semantic-ui-react';
import { withRouter, Link } from 'react-router-dom';
import MobileMenu from './Menu/MobileMenu';
import DesktopTabletMenu from './Menu/DesktopTabletMenu';
import menuItems from './MenuItems/menuItems.json';
import adminItems from './MenuItems/adminMenuItems.json';
import withDataConsumer from '../../api/contextApi/withDataConsumer';
import './Header.css';

class Header extends Component {
  render() {
    const items = this.props.context.loggedIn ? adminItems : menuItems;
    return (
      <div className="Header">
        <Grid className="container">
          <Grid.Row className="Header__TopBar" />
          <Grid.Row verticalAlign="middle" columns={2} className="Header__TitleBar">
            <Grid.Column width={12}>
              <Link to="/">
                <h1>JTV Suriname</h1>
              </Link>
            </Grid.Column>
            <Grid.Column width={4} className="Header__TitleBar__Menu ">
              <MobileMenu menuItems={items} />
              <DesktopTabletMenu menuItems={items} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

export default withRouter(withDataConsumer(Header));



// WEBPACK FOOTER //
// ./src/components/Header/index.js